import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CouponListALV1Component } from './coupon-list-al-v1/coupon-list-al-v1.component';



@NgModule({
  declarations: [CouponListALV1Component],
  exports: [
    CouponListALV1Component,
  ],
  imports: [
    CommonModule
  ],
  providers: [
    CouponListALV1Component,
  ]
})
export class CouponListModule { }
